import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "client-list__filters" }
const _hoisted_2 = { class: "client-list__filters-row" }
const _hoisted_3 = {
  key: 0,
  class: "client-list__filters-tags"
}
const _hoisted_4 = { class: "client-list__filters-tags-item-name" }
const _hoisted_5 = { class: "client-list__filters-counter-value" }
const _hoisted_6 = {
  key: 0,
  class: "client-list__body-divider"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "client-list__empty-count" }

import {
	computed,
	onMounted,
	ref,
	watch
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {searchStore} from "@/store/search";
import { headerStore } from "@/store/header";
import { ClientsApi } from "@/ api/ClientsApi";
import ClientCard from "@/components/main/search-panel/ClientCard.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { TagEntityType } from "@/models/etc/types";
import { i18n } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientList',
  props: {
    isCollapsed: { type: Boolean },
    isSecondCollapsed: { type: Boolean }
  },
  emits: ["on-toggle"],
  setup(__props: any, { emit: __emit }) {

const t = (key: string): string => String(i18n.global.t(key))

const emit = __emit

const props = __props;

const store = searchStore()
const header = headerStore()
const route = useRoute()
const router = useRouter()
const $dropdownRef = ref<typeof AppResizableDropdown | null>(null)
const $clientList = ref<HTMLDivElement | null>(null)
const clientSearch = ref('')
const selectedTags = ref<TagWithFrequency[]>([])
const isCreatingClient = ref(false)
const isCounterHovered = ref(false)

const canCreateClient = computed(() => !!header.currentAccessGroup?.CanCreateClients)
const createClientTitle = computed(() =>
	t(canCreateClient.value ? 'client_create' : 'client_create_unavailable')
)
const createClientHoverColor = computed(() =>
	canCreateClient.value ? '#499259' : '#979797'
)
const createClientCursor = computed(() =>
	isCreatingClient.value ? 'wait' : (canCreateClient.value ? 'pointer' : 'not-allowed')
)

const clientsLoading = computed(() => store.clientsLoading || isCreatingClient.value)
const clientsCount = computed(() => store.clientsCounter)
const hasAnyFilter = computed(() => !!clientSearch.value || selectedTags.value.length > 0)
const clients = computed(() => store.allClientsHighlighted)
const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$clientList,
	'.searchResultContainer',
	() => clients.value
)

const onCreateClient = async () => {
	if (isCreatingClient.value) return
	if (!canCreateClient.value || header.currentAccessGroupId == null) return

	try {
		isCreatingClient.value = true
		const newId = await ClientsApi.createClient(header.currentAccessGroupId)
		if (newId) {
			await router.push({
				path: '/main',
				query: {
					page: 'client',
					id: String(newId),
				}
			})
		}
	} catch (e) {
		console.error(e)
	} finally {
		isCreatingClient.value = false
	}
}

const onClientsScroll = () => {
	const el = $clientList.value
	if (!el || clientsLoading.value) {
		return
	}
	if (el.scrollTop + el.clientHeight >= el.scrollHeight - 800) {
		store.getClientsPartial(clientSearch.value, selectedTags.value.map(tag => tag.Id))
	}
}

onMounted(async () => {
	await store.getInitClients()
})

const searchClients = async () => {
	$clientList.value ? $clientList.value.scrollTop = 0 : null
	await store.getClientsStartPack(clientSearch.value, selectedTags.value.map(tag => tag.Id))
}

const dropFilters = async () => {
	clientSearch.value = ''
	selectedTags.value = []
	await searchClients()
}

const dropTag = async (tag: TagWithFrequency) => {
	selectedTags.value = selectedTags.value.filter(sTag => sTag.Id !== tag.Id )
}

watch(clientSearch, (newVal, oldVal) => {
	if (!newVal && oldVal) {
		searchClients()
	}
})

watch(selectedTags, (newVal) => {
	if (!newVal.length) {
		searchClients()
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
		'client-list': true,
		'client-list--empty': props.isCollapsed,
	})
  }, [
    (!props.isCollapsed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AppTooltip, { text: createClientTitle.value }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "client-list__filters-btn",
                    name: "plus",
                    width: "20px",
                    color: "#979797",
                    "hover-color": createClientHoverColor.value,
                    cursor: createClientCursor.value,
                    onClick: onCreateClient
                  }, null, 8, ["hover-color", "cursor"])
                ]),
                _: 1
              }, 8, ["text"]),
              _createVNode(AppInput, {
                modelValue: clientSearch.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clientSearch).value = $event)),
                class: "client-list__filters-search",
                placeholder: _ctx.$t('search_label'),
                "show-search-button": "",
                onPressEnter: searchClients,
                onSearch: searchClients
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(AppResizableDropdown, {
                ref_key: "$dropdownRef",
                ref: $dropdownRef,
                position: "right",
                "close-by-click-outside": true,
                "max-width": 640,
                "max-height": 436,
                name: "$dropdownRefClientsTags"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "client-list__filters-btn",
                    name: "hash",
                    width: "20px",
                    color: "#979797",
                    "hover-color": "#499259",
                    title: _ctx.$t('file_add_tag'),
                    cursor: "pointer"
                  }, null, 8, ["title"])
                ]),
                default: _withCtx(() => [
                  _createVNode(AppTagSelector, {
                    modelValue: selectedTags.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTags).value = $event)),
                    "entity-type": _unref(TagEntityType).Client,
                    mode: "filter",
                    "allow-create": "",
                    onClose: _cache[2] || (_cache[2] = ($event: any) => ($dropdownRef.value?.close()))
                  }, null, 8, ["modelValue", "entity-type"])
                ]),
                _: 1
              }, 512)
            ]),
            (selectedTags.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "client-list__filters-tags-item",
                      key: tag.Id
                    }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(tag.Name), 1),
                      _createVNode(AppIcon, {
                        class: "client-list__filters-tags-item-delete",
                        name: "close-bold",
                        size: "12px",
                        color: "#D2D2D2",
                        "hover-color": "#4D4D4D",
                        cursor: "pointer",
                        onClick: _withModifiers(($event: any) => (dropTag(tag)), ["stop"])
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "client-list__filters-counter",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('on-toggle'))),
              onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (isCounterHovered.value = true)),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (isCounterHovered.value = false))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(hasAnyFilter.value ? 'clients_found' : 'clients_total')) + ":  ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(clientsCount.value), 1),
              _createVNode(AppIcon, {
                class: "client-list__filters-counter-icon",
                name: props.isSecondCollapsed ? 'small-screen' : 'full-screen',
                size: "14px",
                color: isCounterHovered.value ? '#438451' : '#979797',
                "hover-color": "#438451",
                cursor: "pointer"
              }, null, 8, ["name", "color"]),
              (hasAnyFilter.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "client-list__filters-counter-drop-filters",
                    onClick: _withModifiers(dropFilters, ["stop"])
                  }, _toDisplayString(_ctx.$t('selector_reset')), 1))
                : _createCommentVNode("", true)
            ], 32)
          ]),
          _createElementVNode("div", {
            ref_key: "$clientList",
            ref: $clientList,
            class: "client-list__body",
            onScroll: onClientsScroll
          }, [
            (clientsLoading.value)
              ? (_openBlock(), _createBlock(AppLoader, {
                  key: 0,
                  style: _normalizeStyle(loaderStyle.value)
                }, null, 8, ["style"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: client.Id
              }, [
                _createVNode(ClientCard, {
                  client: client,
                  "text-filter": clientSearch.value
                }, null, 8, ["client", "text-filter"]),
                (index + 1 < clients.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createVNode(AppScrollTopButton, {
              enabled: _unref(isScrollTopEnabled),
              onOnClick: _unref(scrollToTop)
            }, null, 8, ["enabled", "onOnClick"])
          ], 544)
        ], 64))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "client-list__empty",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('on-toggle'))),
          onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (isCounterHovered.value = true)),
          onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (isCounterHovered.value = false)),
          title: _ctx.$t('ui_expand')
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t(hasAnyFilter.value ? 'clients_found' : 'clients_total')) + ":  ", 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(clientsCount.value), 1),
          _createVNode(AppIcon, {
            class: "client-list__empty-icon",
            name: "full-screen",
            width: "14px",
            color: isCounterHovered.value ? '#438451' : '#979797',
            "hover-color": "#438451"
          }, null, 8, ["color"])
        ], 40, _hoisted_7))
  ], 2))
}
}

})